import { ComputedRef } from 'vue'

import { PageType } from '@/domain/value_objects/frame/PageType'
import { FrameStateViewModel } from '@/presentation/viewmodels/frame/frameStateViewModel'

export class FrameStatePresenter {
  private viewModel: FrameStateViewModel

  constructor(viewModel: FrameStateViewModel) {
    this.viewModel = viewModel
  }

  get leftSideFrame(): ComputedRef<PageType> {
    return this.viewModel.leftSideFrame
  }

  get rightSideFrame(): ComputedRef<PageType> {
    return this.viewModel.rightSideFrame
  }

  get isHandlingSlideBar(): ComputedRef<boolean> {
    return this.viewModel.isHandlingSlideBar
  }

  get minLeftSideFrameWidth(): ComputedRef<number> {
    return this.viewModel.minLeftSideFrameWidth
  }

  get maxLeftSideFrameWidth(): ComputedRef<number> {
    return this.viewModel.maxLeftSideFrameWidth
  }

  get leftSideFrameWidth(): ComputedRef<number> {
    return this.viewModel.leftSideFrameWidth
  }

  setLeftSideFrame(leftSideFrame: PageType): void {
    this.viewModel.setLeftSideFrame(leftSideFrame)
  }

  setRightSideFrame(rightSideFrame: PageType): void {
    this.viewModel.setRightSideFrame(rightSideFrame)
  }

  setIsHandlingSlideBar(flag: boolean): void {
    this.viewModel.setIsHandlingSlideBar(flag)
  }

  mouseDownSlideBar = () => {
    this.viewModel.setIsHandlingSlideBar(true)
  }
  mouseUpSlideBar = () => {
    this.viewModel.setIsHandlingSlideBar(false)
  }

  setLeftSideFrameWidth(width: number): void {
    this.viewModel.setLeftSideFrameWidth(width)
  }

  setMaxLeftSideFrameWidth(width: number): void {
    this.viewModel.setMaxLeftSideFrameWidth(width)
  }

  resizeLeftSideFrameWidth = (e: MouseEvent) => {
    // フレーム幅を変更
    if (!this.viewModel.isHandlingSlideBar.value) return
    const newWidth = this.viewModel.leftSideFrameWidth.value + e.movementX
    this.viewModel.setLeftSideFrameWidth(
      newWidth > this.viewModel.minLeftSideFrameWidth.value && newWidth < this.viewModel.maxLeftSideFrameWidth.value
        ? newWidth
        : this.viewModel.leftSideFrameWidth.value
    )
  }

  resizeMaxLeftSideFrameWidth = () => {
    const windowWidth = window.innerWidth
    this.viewModel.setMaxLeftSideFrameWidth(windowWidth - 700)
    this.viewModel.setLeftSideFrameWidth(windowWidth / 2 - 100)
  }

  initFrameState(): void {
    this.viewModel.setLeftSideFrame('Problem')
    this.viewModel.setRightSideFrame('Editor')
  }
}
